export default {
      id: "ic_profile-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ic_profile",
      toString: function () {
        return this.url;
      }
    }